export const THAINOW_USER_OBJ = "thainow.user";
export const THAINOW_RECENT_SIGN_IN_OBJ = "thainow.recentSignin";
export const THAINOW_USER_SIGN_UP_OBJ = "thainow.user.signup.info";
export const THAINOW_COMPANY_SIGN_UP_OBJ = "thainow.company.signup.info";
export const THAINOW_SEARCH_OBJ = "thainow.search.info";
export const THAINOW_USER_SIGN_IN_OBJ = "thainow.user.signin.info";
export const THAINOW_OFF_CANVAS_OBJ = "thainow.offcanvas.info";
export const THAINOW_USER_PROFILE_OBJ = "thainow.user.profile";
export const THAINOW_COMPANY_PROFILE_OBJ = "thainow.company.profile";
export const SUPPORT_EMAIL = "projectthaihub@gmail.com";

export const USER_REDUCER = "useReducer";

export const THAINOW_REDUX_STORE_ROOT_OBJ = "reduxStoreObj";
export const THAINOW_REDUX_STORE_ROOT_OBJ_PROPS = "reduxStoreObjProps";

export const IMAGE_THAINOW_LOGO = "thainowLogo";
export const IMAGE_THAINOW_LOGO_ROUND = "thainowLogoRound";
export const IMAGE_GUEST_PROFILE = "guestProfile";
export const IMAGE_CLASSIC_PROFILE = "classicProfile";
export const IMAGE_BUSINESS_PROFILE = "businessProfile";
export const IMAGE_ADD_FRAME = "addFrameImage";
export const IMAGE_BLUR_THAINOW = "thainowBlurImage";

export const SHOW_OFF_CANVAS = "showOffCanvas";

export const FORWARD_CONTINUE = "continue";
export const FORWARD_CLOSE = "close";
export const FORWARD_SUCCESS = "success";

export const CONTINUE_URL = "continueUrl";
export const SUCCESS_URL = "successUrl";
export const CLOSE_URL = "closeUrl";

export const ICON_USER_READER = "userReaderIcon";
export const ICON_LOCATION = "locationIcon";
export const ICON_SEARCH = "searchIcon";
export const ICON_SEARCH_WHITE = "searchIconWhite";
export const ICON_EMAIL_BLACK = "emailIconBlack";
export const ICON_PHONE_BLACK = "phoneIconBlack";
export const ICON_NOTIFICATION_BLACK = "notificationBlack";
export const ICON_THREE_BARS_BLACK = "3barsBlack";
export const ICON_US_PHONE = "usPhoneIcon";

export const LOCATION_OBJ = "locationObj";
export const LOCATION_PROP = "location";
export const LOCALITY_PROP = "locality";
export const IS_LOCATION_PUBLIC = "isLocationPublic";
export const ADDRESS_PROP = "address";
export const PLACEID_PROP = "placeid";
export const ZIP_CODE_PROP = "zipcode";
export const STATE_PROP = "state";
export const LAT_PROP = "lat";
export const LNG_PROP = "lng";

export const ACCOUNT_OBJ = "account";
export const ACCOUNT_ID_PROP = "accountId";

export const PROFILE_OBJ = "profile";
export const PROFILE_ID_PROP = "profileId";
export const PROFILE_TYPE_PROP = "type";
export const PROFILE_GUEST_TYPE_PROP = "guestProfile";
export const PROFILE_USER_TYPE_PROP = "USER_PROFILE";
export const PROFILE_BUSINESS_TYPE_PROP = "BUSINESS_PROFILE";
export const PROFILE_AVATAR_PROP = "avatarUrl";
export const PROFILE_NAME_PROP = "name";
export const PROFILE_STATUS_PROP = "status";
export const UPLOAD_PHOTO_HANDLER = "uploadPhotoHandler";
export const VISIT_MY_PROFILE_HANDLER = "visitMyProfileHandler";

export const ACCESS_TOKEN_PROP = "access_token";
export const USER_PROP = "user";
export const ID_PROP = "id";
export const INFO_PROP = "info";
export const NAME_PROP = "name";
export const USERNAME_PROP = "username";
export const FIRSTNAME_PROP = "firstName";
export const IS_FIRSTNAME_PUBLIC_PROP = "isFirstNamePublic";
export const LASTNAME_PROP = "lastName";
export const IS_LASTNAME_PUBLIC_PROP = "isLastNamePublic";
export const EMAIL_PROP = "email";
export const EMAIL_VALIDATION = "isValidEmail";
export const IS_EMAIL_PUBLIC_PROP = "isEmailPublic";
export const PHONE_PROP = "phone";
export const REGION_PROP = "region";
export const SMS_PROP = "sms";
export const PHONE_VALIDATION = "isValidPhone";
export const IS_PHONE_PUBLIC_PROP = "isPhonePublic";
export const PASSWORD_PROP = "password";
export const CURRENT_PASSWORD_PROP = "currentPassword";
export const CONFIRM_PASSWORD_PROP = "confirmPassword";
export const PASSWORD_VALIDATION = "isValidPassword";
export const CONFIRM_PASSWORD_VALIDATION = "isPasswordMatch";
export const URL_PROP = "url";
export const BANNER_URL_PROP = "bannerUrl";

export const VERIFICATION_METHOD_PROP = "verifyMethod";
export const CHANNEL_PROP = "channel";
export const SIGNIN_CHANNEL_THAINOW = "thainow";
export const SIGNIN_CHANNEL_GOOGLE = "google";
export const SIGNIN_CHANNEL_APPLE = "apple";
export const SIGNIN_CHANNEL_FACEBOOK = "facebook";
export const SIGNIN_CHANNEL_LINE = "line";
export const OTP_PROP = "otpToken";
export const OTP_VALIDATION = "isValidOtp";
export const PRIVILEGES_PROP = "privileges";
export const POSITION_PROP = "administratorRole";
export const ROLE_PROP = "role";
export const PENDING_STATUS_PROP = "PENDING";
export const DISABLED_PROP = "disabled";
export const AGREEMENT_PROP = "agreement";
export const WEBSITE_PROP = "website";
export const IS_WEBSITE_PUBLIC_PROP = "isWebsitePublic";
export const PICTURE_PROP = "picture";
export const COVER_PICTURES_PROP = "coverPictures";
export const DESCRIPTION_PROP = "description";
export const IS_DESCRIPTION_PUBLIC_PROP = "isDescriptionPublic";
export const SIZE_PROP = "size";
export const IS_SIZE_PUBLIC_PROP = "isSizePublic";
export const UPDATED_ON_PROP = "updatedOn";
export const STATUS_PROP = "status";
export const CATEGORY_PROP = "category";
export const CONTACT_INFO_PROP = "contactInfo";
export const EXPIRED_ON_PROP = "expiredOn";
export const TITLE_PROP = "title";
export const PICTURE_LIST_PROP = "pictures";
export const CHECKBOX_PROP = "checkbox";
export const DATE_PROP = "date";
export const EDIT_PROP = "edit";
export const CREATE_PROP = "create";
export const TYPE_PROP = "type";

export const PROFILE_REVIEW_PROP = "PROFILE_REVIEW";
export const SERVICE_REVIEW_PROP = "POST_REVIEW";
export const REVIEWER_PROP = "reviewer";
export const REVIEWER_ID_PROP = "reviewerId";
export const REVIEWEE_ID_PROP = "revieweeId";
export const COMMENT_PROP = "comment";
export const TOTAL_REVIEW_PROP = "totalReview";
export const AVG_RATING_PROP = "avgRating";
export const TOTAL_COUNT_PROP = "totalCount";
export const RATE_PROP = "rate";

export const REPORT_USER_TYPE_PROP = "USER_REPORT";
export const REPORT_SERVICE_TYPE_PROP = "SERVICE_REPORT";
export const REPORT_SENDER_PROP = "sender";
export const REPORT_TYPE_PROP = "type";
export const REPORT_TYPE_ID_PROP = "typeId";
export const REPORT_MESSAGE_PROP = "message";
export const REPORT_REASON_LIST_PROP = "reasons";

export const REDIRECT_URI = "redirectUri";
export const SIGN_IN_PATH = "/signin";
export const SWITCH_PROFILE_PATH = "/switch-profiles";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const SIGN_UP_PATH = "/signup";
export const MY_PROFILE_PATH = "/my-profile";
export const HELP_CENTER_PATH = "/help-center";
export const GUIDE_BOOK_PATH = "/guidebook";
export const GUIDE_BOOK_NEW_POST_PATH = "/guidebook/new-post";
export const GUIDE_BOOK_EDIT_POST_PATH = "/guidebook/edit-post";
export const TERM_PATH = "/term-agreement";
export const POLICY_PATH = "/policy";

export const GUIDE_BOOK_PROP = "guideBook";

export const COMPANY_INDUSTRY_LIST = [
	"Aquarium & Pet",
	"Attorney",
	"Auto Service",
	"Bank",
	"Bar",
	"Bodyshop",
	"Book Store",
	"Bookkeeping",
	"Boxing",
	"Car Dealer",
	"Car Towing",
	"Chiropractic",
	"Clothing",
	"Community Service",
	"Construction",
	"Consulate",
	"Consultant",
	"Cosmetic",
	"Customer Service",
	"Credit Card Services",
	"Dance",
	"Dentist",
	"Doctor Clinic",
	"Drink & Dessert",
	"DVD, CD, Games",
	"Education",
	"Elderly Care",
	"Embassy",
	"Factory",
	"Florist",
	"Fusion Restaurant",
	"Gift Shop",
	"Hair Salon",
	"Handyman",
	"Insurance",
	"Information Technology",
	"Japanese Restaurant",
	"Jewelry & Watch",
	"Market",
	"Mobile",
	"Money Transfer",
	"Nail",
	"Newspaper",
	"Notary Public",
	"Optical",
	"Painter",
	"Personal Trainer",
	"Printing",
	"Real Estate",
	"School",
	"Shipping",
	"Tailor",
	"Tax",
	"Taxi",
	"Television",
	"Thai Church",
	"Thai Massage",
	"Thai Restaurant",
	"Thai Temple",
	"Trader",
	"Travel Agency",
	"Vegan Restaurant",
];
export const COMPANY_POSTION_LIST = [
	"Owner",
	"Manager",
	"Representative",
	"No Preference",
];
export const COMPANY_SIZE_LIST = [
	"Micro (1-10)",
	"Small (10-100)",
	"Medium (101-999)",
	"Large (1000+)",
	"No preference",
];

// export const COMPANY_PROP = "company";
// export const COMPANY_LIST = "companies";
export const COMPANY_INDUSTRY_PROP = "industry";
export const COMPANY_FOUNDED_PROP = "founded";
export const COMPANY_NAME_PROP = "name";
export const COMPANY_REVENUE_PROP = "revenue";
export const COMPANY_SIZE_PROP = "size";
export const IS_COMPANY_INFORMAL_PROP = "isInformal";

// export const COMPANY_ADDRESS_PROP = "address";

// export const COMPANY_EMAIL_PROP = "email";
// export const COMPANY_EMAIL_VALIDATION = "isValidEmail";
// export const COMPANY_PHONE_PROP = "phone";
// export const COMPANY_PHONE_VALIDATION = "isValidPhone";
// export const COMPANY_WEBSITE_PROP = "website";
// export const COMPANY_WEBSITE_VALIDATION = "isValidWebsite";

// export const COMPANY_SUBMIT_EXTRA_INFO_VALIDATION = "isSummitExtraInfo";
// export const COMPANY_STATUS_PROP = "status";

export const SERVICE_ID_PROP = "postId";
export const POST_OWNER_PROP = "postOwner";
export const POST_OWNER_ID_PROP = "ownerId";
export const POST_TYPE_PROP = "type";
export const CREATED_ON_PROP = "createdOn";
export const DEFAULT_POST_OWNER_INFO = {
	[`${ID_PROP}`]: -1,
	[`${TOTAL_REVIEW_PROP}`]: 0,
	[`${AVG_RATING_PROP}`]: 0,
	[`${INFO_PROP}`]: {},
};

export const DEFAULT_USER_INFO = {
	[`${CREATED_ON_PROP}`]: "",
	[`${DESCRIPTION_PROP}`]: "",
	[`${IS_DESCRIPTION_PUBLIC_PROP}`]: false,
	[`${EMAIL_PROP}`]: "",
	[`${IS_EMAIL_PUBLIC_PROP}`]: false,
	[`${FIRSTNAME_PROP}`]: "",
	[`${LASTNAME_PROP}`]: "",
	[`${LOCATION_PROP}`]: {},
	[`${IS_LOCATION_PUBLIC}`]: false,
	[`${NAME_PROP}`]: "",
	[`${PHONE_PROP}`]: "",
	[`${IS_PHONE_PUBLIC_PROP}`]: false,
	[`${PICTURE_PROP}`]: "",
	[`${PICTURE_LIST_PROP}`]: [],
	[`${WEBSITE_PROP}`]: "",
	[`${IS_WEBSITE_PUBLIC_PROP}`]: false,
	[`${UPDATED_ON_PROP}`]: "",
};

export const BUSINESS_HEADLINE_PROP = "Thai Business";
export const DEFAULT_BUSINESS_INFO = {
	[`${PICTURE_LIST_PROP}`]: [],
	[`${DESCRIPTION_PROP}`]: "",
	[`${IS_DESCRIPTION_PUBLIC_PROP}`]: true,
	[`${EMAIL_PROP}`]: "",
	[`${IS_EMAIL_PUBLIC_PROP}`]: true,
	[`${COMPANY_FOUNDED_PROP}`]: "",
	[`${COMPANY_INDUSTRY_PROP}`]: "",
	[`${COMPANY_NAME_PROP}`]: "",
	[`${PHONE_PROP}`]: "",
	[`${IS_PHONE_PUBLIC_PROP}`]: true,
	[`${PICTURE_PROP}`]: "",
	[`${COMPANY_REVENUE_PROP}`]: "",
	[`${SIZE_PROP}`]: "",
	[`${IS_SIZE_PUBLIC_PROP}`]: true,
	[`${STATUS_PROP}`]: "UNREGISTERED",
	[`${UPDATED_ON_PROP}`]: "",
	[`${WEBSITE_PROP}`]: "",
	[`${IS_WEBSITE_PUBLIC_PROP}`]: true,
	[`${LOCATION_PROP}`]: {},
};

export const DEFAULT_CONTACT_INFO = {
	[`${EMAIL_PROP}`]: "",
	[`${PHONE_PROP}`]: "",
	[`${WEBSITE_PROP}`]: "",
};

export const PUBLIC_POST_STATUS_PROP = "AVAILABLE";
export const PRIVATE_POST_STATUS_PROP = "PRIVATE";

export const DEAL_HEADLINE_PROP = "Local Deals";
export const DEAL_POST_TYPE_PROP = "DEAL_POST";
export const DEFAULT_DEAL_INFO = {
	[`${CATEGORY_PROP}`]: "",
	[`${CONTACT_INFO_PROP}`]: { ...DEFAULT_CONTACT_INFO },
	[`${EXPIRED_ON_PROP}`]: "",
	[`${TITLE_PROP}`]: "",
	[`${PICTURE_LIST_PROP}`]: [],
	[`${STATUS_PROP}`]: "",
	[`${UPDATED_ON_PROP}`]: "",
	[`${DESCRIPTION_PROP}`]: "",
	[`${LOCATION_PROP}`]: {},
};

export const JOB_HEADLINE_PROP = "Job Hiring";
export const JOB_POST_TYPE_PROP = "JOB_POST";
export const EXPERIENCE_PROP = "experience";
export const POSITION_LIST_PROP = "positions";
export const IS_REMOTE_PROP = "isRemote";
export const SALARY_PROP = "salary";
export const SKILL_PROP = "skills";
export const DEFAULT_POSITION_LIST = [
	"All",
	"Full-time",
	"Part-time",
	"Internship",
	"Seasonal",
	"Freelance",
	"Volunteer",
];
export const DEFAULT_JOB_INFO = {
	[`${EXPERIENCE_PROP}`]: "",
	[`${CONTACT_INFO_PROP}`]: { ...DEFAULT_CONTACT_INFO },
	[`${EXPIRED_ON_PROP}`]: "",
	[`${TITLE_PROP}`]: "",
	[`${PICTURE_LIST_PROP}`]: [],
	[`${POSITION_LIST_PROP}`]: [],
	[`${IS_REMOTE_PROP}`]: false,
	[`${SALARY_PROP}`]: "",
	[`${SKILL_PROP}`]: "",
	[`${STATUS_PROP}`]: "",
	[`${UPDATED_ON_PROP}`]: "",
	[`${DESCRIPTION_PROP}`]: "",
	[`${LOCATION_PROP}`]: {},
};

export const HOUSING_HEADLINE_PROP = "Housing";
export const HOUSING_POST_TYPE_PROP = "HOUSING_POST";
export const AMENITY_LIST_PROP = "amenities";
export const AMENITY_WIFI_PROP = "WIFI";
export const AMENITY_WASHER_PROP = "WASHER";
export const AMENITY_REFRIGERATOR_PROP = "REFRIGERATOR";
export const AMENITY_COOKING_BASIC_PROP = "COOKING BASIC";
export const AMENITY_AIR_CONDITIONER_PROP = "AIR CONDITIONER";
export const AMENITY_DRYER_PROP = "DRYER";
export const AMENITY_MICROWAVE_PROP = "MICROWAVE";
export const AMENITY_PET_ALLOWED_PROP = "PET ALLOWED";

export const AMENITY_ICON_LIST = {};

export const ANNUAL_COST_PROP = "annualCost";
export const DAILY_COST_PROP = "dailyCost";
export const DEPOSIT_COST_PROP = "depositCost";
export const MONTHLY_COST_PROP = "monthlyCost";
export const INTERIOR_PROP = "interior";
export const INTERIOR_GUEST_PROP = "guest";
export const INTERIOR_BED_PROP = "bed";
export const INTERIOR_PARKING_PROP = "parking";
export const INTERIOR_BATH_PROP = "bath";
export const HOUSING_TYPE_PROP = "type";

export const DEFAULT_HOUSING_INFO = {
	[`${AMENITY_LIST_PROP}`]: [],
	[`${ANNUAL_COST_PROP}`]: "",
	[`${DAILY_COST_PROP}`]: "",
	[`${MONTHLY_COST_PROP}`]: "",
	[`${DEPOSIT_COST_PROP}`]: "",
	[`${CATEGORY_PROP}`]: "",
	[`${CONTACT_INFO_PROP}`]: { ...DEFAULT_CONTACT_INFO },
	[`${DESCRIPTION_PROP}`]: "",
	[`${EXPIRED_ON_PROP}`]: "",
	[`${PICTURE_LIST_PROP}`]: [],
	[`${INTERIOR_PROP}`]: [],
	[`${STATUS_PROP}`]: "",
	[`${TITLE_PROP}`]: "",
	[`${HOUSING_TYPE_PROP}`]: "",
	[`${UPDATED_ON_PROP}`]: "",
	[`${LOCATION_PROP}`]: {},
};

export const MARKETPLACE_HEADLINE_PROP = "Marketplace";
export const MARKETPLACE_POST_TYPE_PROP = "MARKETPLACE_POST";
export const CONDITION_PROP = "condition";
export const COST_PROP = "cost";
export const DEFAULT_MARKETPLACE_INFO = {
	[`${CATEGORY_PROP}`]: "",
	[`${CONDITION_PROP}`]: "",
	[`${COST_PROP}`]: "",
	[`${CONTACT_INFO_PROP}`]: { ...DEFAULT_CONTACT_INFO },
	[`${DESCRIPTION_PROP}`]: "",
	[`${EXPIRED_ON_PROP}`]: "",
	[`${PICTURE_LIST_PROP}`]: [],
	[`${LOCATION_PROP}`]: {},
	[`${STATUS_PROP}`]: "",
	[`${TITLE_PROP}`]: "",
	[`${UPDATED_ON_PROP}`]: "",
};

export const DEFAULT_CARD_INFO = {
	[`${ID_PROP}`]: -1,
	[`${TOTAL_REVIEW_PROP}`]: 0,
	[`${AVG_RATING_PROP}`]: 0,
	[`${POST_OWNER_PROP}`]: {},
	// [`${SEARCH_TYPE_PROP}`]: SEARCH_BUSINESS,
};

export const SEARCH_REQUEST = "search";
export const SEARCH_OBJ = "searchObj";
export const SEARCH_REQUESTER_ID = "requesterId";
export const SEARCH_RESULT_OBJ = "searchResultObj";
export const SEARCH_FETCH_RESULT_PROP = "fetchResult";
export const SEARCH_TOTAL_COUNT_PROP = "totalCount";
export const SEARCH_TOTAL_PAGE_PROP = "totalPage";
export const SEARCH_INPUT_PROP = "input";
export const SEARCH_TYPE_PROP = "searchType";
export const SEARCH_LOCATION_ADDRESS = "address";
export const SEARCH_PROFILE = "profiles";
export const SEARCH_SERVICE = "posts";
export const SEARCH_WISHLIST = "wishlists";
export const SEARCH_QUESTION = "questions";
export const SEARCH_REVIEW = "reviews";
export const SEARCH_USER = "users";
export const SEARCH_BUSINESS = "business";
export const SEARCH_DEAL = "deals";
export const SEARCH_JOB = "jobs";
export const SEARCH_HOUSING = "housings";
export const SEARCH_MARKETPLACE = "marketplaces";
export const SEARCH_KEYWORD = "keywords";
export const SEARCH_SORT = "sort";
export const SEARCH_SORT_DATE = "Date";
export const SEARCH_SORT_DISTANCE = "Distance";
export const SEARCH_SORT_ORDER = "sortOrder";
export const SEARCH_SORT_ACS = "asc";
export const SEARCH_SORT_DESC = "desc";
export const SEARCH_DEFAULT_LOCATION = {
	[`${ADDRESS_PROP}`]: "Thai Town, Los Angeles, CA 90027, USA",
	[`${PLACEID_PROP}`]: "ChIJf2z2Hle_woARaNaIiR198fg",
};
export const SEARCH_PAGE_PROP = "page";
export const SEARCH_FILTER = "filter";
export const SEARCH_FILTER_DEAL_FIELD_LIST = [CATEGORY_PROP, STATUS_PROP];
export const SEARCH_FILTER_JOB_FIELD_LIST = [
	POSITION_LIST_PROP,
	EXPERIENCE_PROP,
];
export const SEARCH_FILTER_HOUSING_FIELD_LIST = [
	HOUSING_TYPE_PROP,
	CATEGORY_PROP,
	AMENITY_LIST_PROP,
];
export const SEARCH_FILTER_MARKETPLACE_FIELD_LIST = [
	CONDITION_PROP,
	CATEGORY_PROP,
];
export const SEARCH_FILTER_BUSINESS_FILED_LIST = [COMPANY_INDUSTRY_PROP];
export const SEARCH_FILTER_FIELD_LIST = [
	...SEARCH_FILTER_DEAL_FIELD_LIST,
	...SEARCH_FILTER_JOB_FIELD_LIST,
	...SEARCH_FILTER_HOUSING_FIELD_LIST,
	...SEARCH_FILTER_MARKETPLACE_FIELD_LIST,
	...SEARCH_FILTER_BUSINESS_FILED_LIST,
	SEARCH_FILTER,
];

export const ERROR = "ERROR";
export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const ERROR_TYPE = "ERROR_STATUS";
